'use client'
import { Sidebar, SidebarFooter, useSidebar } from '@/components/ui/sidebar'
import {
  AppSidebarContent as NotificationSidebarContent,
  AppSidebarHeader as NotificationSidebarHeader,
} from './notification'
import {
  AppSidebarContent as SaveSidebarContent,
  AppSidebarHeader as SaveSidebarHeader,
} from './save'
import {
  AppSidebarContent as NavbarSidebarContent,
  AppSidebarHeader as NavbarSidebarHeader,
} from './navbar'
import {
  AppSidebarContent as FilterSidebarContent,
  AppSidebarHeader as FilterSidebarHeader,
} from './filter'
import {
  AppSidebarContent as NotificationSettingsSidebarContent,
  AppSidebarHeader as NotificationSettingsSidebarHeader,
} from './notification-settings'
import {
  AppSidebarContent as ProfileSidebarContent,
  AppSidebarHeader as ProfileSidebarHeader,
} from './profile'
import {
  AppSidebarContent as GeneralSidebarContent,
  AppSidebarHeader as GeneralSidebarHeader,
} from './profile/general'
import {
  AppSidebarContent as PreferenceSidebarContent,
  AppSidebarHeader as PreferenceSidebarHeader,
} from './preference'

const sidebarComponents = {
  notification: {
    Header: NotificationSidebarHeader,
    Content: NotificationSidebarContent,
  },
  save: {
    Header: SaveSidebarHeader,
    Content: SaveSidebarContent,
  },
  navbar: {
    Header: NavbarSidebarHeader,
    Content: NavbarSidebarContent,
  },
  filter: {
    Header: FilterSidebarHeader,
    Content: FilterSidebarContent,
  },
  notificationsettings: {
    Header: NotificationSettingsSidebarHeader,
    Content: NotificationSettingsSidebarContent,
  },
  profile: {
    Header: ProfileSidebarHeader,
    Content: ProfileSidebarContent,
  },
  general: {
    Header: GeneralSidebarHeader,
    Content: GeneralSidebarContent,
  },
  preference: {
    Header: PreferenceSidebarHeader,
    Content: PreferenceSidebarContent,
  },
}

export function AppSidebar() {
  const { contentType } = useSidebar()
  const { Header, Content } = sidebarComponents[contentType] || {}

  return (
    <Sidebar variant="sidebar" side="right">
      {Header && <Header />}
      {Content && <Content />}
      <SidebarFooter />
    </Sidebar>
  )
}
